import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Calendar, Clock, Phone, Map } from 'lucide-react';

const Contact: React.FC = () => {
  const contactInfo = [
    {
      icon: <MapPin className="w-6 h-6" />,
      title: 'Atrašanās vieta',
      details: ['Dadzis - dabas draugu centrs', 'Mežniecība, Teveņāni', 'Viļānu pagasts, LV-4650'],
      bgColor: 'bg-primary-900/20',
      borderColor: 'border-primary-500/30',
      iconColor: 'text-primary-400'
    },
    {
      icon: <Calendar className="w-6 h-6" />,
      title: 'Datumi',
      details: ['26. decembris, 2025', 'Piektdiena', '1 diena'],
      bgColor: 'bg-secondary-900/20',
      borderColor: 'border-secondary-500/30',
      iconColor: 'text-secondary-400'
    },
    {
      icon: <Clock className="w-6 h-6" />,
      title: 'Laiki',
      details: ['Sākums: 11:00', 'Beigas: 21:00', 'Ēdieni: 12:00-13:00 un 15:30-16:30'],
      bgColor: 'bg-accent-900/20',
      borderColor: 'border-accent-500/30',
      iconColor: 'text-accent-400'
    },
    {
      icon: <Phone className="w-6 h-6" />,
      title: 'Saziņa',
      details: ['Telefons: +371 24904140', 'E-pasts: ezaurins@pm.me'],
      bgColor: 'bg-green-900/20',
      borderColor: 'border-green-500/30',
      iconColor: 'text-green-400'
    }
  ];


  return (
    <section id="contact" className="py-20 relative overflow-hidden bg-gray-900">
      <div className="relative container mx-auto px-4 z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary-300 via-primary-100 to-accent-200 mb-6">
            Kontakti un Informācija
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Ir jautājumi par nometni? Mēs esam šeit, lai palīdzētu! Sazinies ar mums jebkurā laikā.
          </p>
        </motion.div>

        {/* Contact Information Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {contactInfo.map((info, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              className={`p-6 rounded-2xl border backdrop-blur-md ${info.bgColor} ${info.borderColor} transition-all duration-300 hover:shadow-lg hover:shadow-${info.iconColor}/20`}
            >
              <div className={`text-3xl mb-4 ${info.iconColor}`}>{info.icon}</div>
              <h3 className="text-xl font-bold text-white mb-3">{info.title}</h3>
              <div className="space-y-1">
                {info.details.map((detail, detailIndex) => (
                  <p key={detailIndex} className="text-gray-300 text-sm">
                    {detail}
                  </p>
                ))}
              </div>
            </motion.div>
          ))}
        </div>



        {/* Location Map */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-16 bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/10"
        >
          <h3 className="text-2xl font-bold text-white mb-6 text-center flex items-center justify-center gap-3">
            <Map className="w-8 h-8 text-primary-400" />
            <span>Kā mūs atrast</span>
          </h3>

          <div className="bg-white/5 rounded-2xl overflow-hidden shadow-lg mb-6 border border-white/10">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2175.429657096695!2d26.940652400000003!3d56.5521715!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46c20d94be751d31%3A0x89b58104e36ac2b3!2sDadzis%20-%20dabas%20draugu%20centrs!5e0!3m2!1sen!2slv!4v1712774846744!5m2!1sen!2slv"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Dadzis location"
            ></iframe>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
